/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplateWhatsApp(inboxId){
    return axios.post(`${this.url}/${inboxId}/whatsapp_channels`, {
      inbox_id: inboxId,
    });
  }

  refreshWhatsAppQualityLimits(inboxId) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_quality_limits/refresh`);
  }

  getAdsOptimization(inboxId) {
    return axios.get(`${this.url}/${inboxId}/ads_optimization`);
  }

  updateAdsOptimization(inboxId, payload) {
    return axios.patch(`${this.url}/${inboxId}/ads_optimization`, payload);
  }

  testAdsOptimizationConnection(inboxId, payload = {}) {
    return axios.post(`${this.url}/${inboxId}/ads_optimization/test_connection`, payload);
  }
}

export default new Inboxes();
